
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}


var date = new Date();

//alert(date.addDays(31));

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth(); //January is 0!
var yyyy = today.getFullYear();

var validuntil;

//validuntil='February 28,';

var validuntil = ["January 31, "+yyyy, "February 28, "+yyyy, "March 31, "+yyyy, "April 30, "+yyyy, "May 31, "+yyyy,"June 30, "+yyyy,"July 31, "+yyyy,"August 31, "+yyyy,"September 30, "+yyyy,"October 31, "+yyyy,"November 30, "+yyyy,"December 31, "+yyyy];


//var validuntil = ["January 31, "+yyyy,"February 31, "+yyyy];



/*

validuntil[1]='March 31,';
validuntil[2]='April 30,';
validuntil[3]='May 31,';
validuntil[4]='June 30,';
validuntil[5]='July 31,';
validuntil[6]='August 31,';
validuntil[7]='September 31,';
validuntil[8]='October 30,';
validuntil[9]='November 31,';
validuntil[10]='December 30,';
validuntil[11]='January 31,';
*/

//var nextmonth=today.setMonth(today.getMonth()+1);





//today = mm + '/' + dd + '/' + yyyy;

//alert(today);
document.getElementById("validuntil").innerHTML = validuntil[mm];



//var jan312009 = new Date();
//var eightMonthsFromJan312009  = jan312009.setMonth(jan312009.getMonth()+8);